/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import styles from './styles.module.scss'
import { useDispatch } from 'react-redux'
import { addNewPatient } from '../../../../../Redux/patients/patientsSlice'
import { useTranslation } from 'react-i18next'

const index = ({ close, category, setSelectedPatient }) => {
  const { t } = useTranslation() || ((text) => text)
  const [showAdditional, setShowAdditional] = useState(false)
  const { id, nid, phone, email, dob, full_name, operations, main_issue, examination, ekg, feedback, ...rest } = {
    id: null,
    nid: '',
    phone: '',
    photoURL: '',
    email: '',
    dob: '',
    full_name: '',
    operations: []
  }

  const dispatch = useDispatch()

  const submitData = (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const formObject = {
      email: formData.get('email'),
      full_name: formData.get('full_name'),
      phone: formData.get('phone'),
      nid: formData.get('nid'),
      dob: formData.get('dob'),
      category: category || 'stomatology',
      setterFn: setSelectedPatient,
      close
    }
    formObject.operations = []
    formObject.appointments = []
    formObject.attachements = []
    dispatch(addNewPatient(formObject))
  }

  return (
    <div className={styles.popup_wrapper}>
      <div className={styles.form_header}>
        <h2 className={styles.header_text}>
          {t('ADD_NEW_PATIENT')} ({t(category)})
        </h2>
        <button className={styles.close_btn} onClick={close}>
          ✖
        </button>
      </div>
      <form className={styles.popup_from_container} onSubmit={submitData}>
        <div className={styles.form_entry}>
          <label className={styles.entry_label} htmlFor='full_name'>
            {t('full_name')}
          </label>
          <input defaultValue={full_name} className={styles.entry_input} required type='text' id='full_name' name='full_name' />
        </div>
        <div className={styles.form_entry}>
          <label className={styles.entry_label} htmlFor='dob'>
            {t('date_of_birth')}
          </label>
          <input defaultValue={dob} className={styles.entry_input} type='date' id='dob' name='dob' />
        </div>
        <div className={`${styles.form_entry} ${styles.checkbox_entry}`}>
          <label className={styles.entry_label} htmlFor='show_additional'>
            {t('show_additional_info')}
          </label>
          <input
            className={styles.entry_input}
            type='checkbox'
            id='show_additional'
            name='show_additional'
            onChange={() => setShowAdditional(!showAdditional)}
            checked={showAdditional}
          />
        </div>
        {showAdditional && (
          <div className={styles.additional_info_container}>
            <div className={styles.form_entry}>
              <label className={styles.entry_label} htmlFor='email'>
                {t('email')}
              </label>
              <input defaultValue={email} className={styles.entry_input} required type='email' id='email' name='email' />
            </div>
            <div className={styles.form_entry}>
              <label className={styles.entry_label} htmlFor='phone'>
                {t('phone')}
              </label>
              <input defaultValue={phone} className={styles.entry_input} required type='text' id='phone' name='phone' />
            </div>
            {/* <div className={styles.form_entry}>
              <label className={styles.entry_label} htmlFor='nid'>
                National ID
              </label>
              <input defaultValue={nid} className={styles.entry_input} type='text' id='nid' name='nid' />
            </div> */}
          </div>
        )}
        <div className={`${styles.form_entry} ${styles.buttons_container}`}>
          <button className={styles.submit_button} type='submit'>
            {t('add')}
          </button>
        </div>
      </form>
    </div>
  )
}
export default index
